import {
  LAYOUT_SAVER_HAS_NO_FUNERAL_HOME_REASON,
  LOTUS_GLOBAL_TEMPLATE_REFUSED_CODE,
  ORDER_PAGE_GONE_CODE,
  ORDER_PAGE_TURNED_OVER_CODE,
} from '@messenger/consts'

/**
 * Why a layout save failed, from its answer. Every answer the save routes
 * give means nothing was written, so all but `unknown` say so; `unknown` is a
 * request that got no answer, or a gateway's 502, 503 or 504 in the backend's
 * place, whose outcome the tab cannot know: the transaction may have
 * committed before the answer was lost.
 */
export type LayoutSaveFailure =
  | 'turnedOver'
  | 'pagesGone'
  | 'lotusRefused'
  | 'noFuneralHome'
  | 'notSaved'
  | 'unknown'

export const layoutSaveFailure = (error: unknown): LayoutSaveFailure => {
  const response = (
    error as {
      response?: {
        status?: number
        data?: { code?: string; data?: { reason?: string } }
      }
    } | null
  )?.response
  if (!response || [502, 503, 504].includes(response.status ?? 0))
    return 'unknown'
  const code = response.data?.code
  if (code === ORDER_PAGE_TURNED_OVER_CODE) return 'turnedOver'
  if (code === ORDER_PAGE_GONE_CODE) return 'pagesGone'
  if (code === LOTUS_GLOBAL_TEMPLATE_REFUSED_CODE) return 'lotusRefused'
  if (response.data?.data?.reason === LAYOUT_SAVER_HAS_NO_FUNERAL_HOME_REASON)
    return 'noFuneralHome'
  return 'notSaved'
}
